module.exports = __webpack_public_path__ + "img/splitFileNum4.db7272a1.svg";